import { styled } from '@mui/system';
import { TextField } from 'react-admin';

export const MyTextField = styled(TextField)({
    fontSize: "14px",
    "& .RaLabeled-label": {
        fontSize: "14px",
    },
});